export default __webpack_public_path__ + "static/toallas-65905d4c86a30baec226060f976dad9f.png";